import { Component } from '@angular/core';

@Component({
  selector: 'uni-action-widget-container',
  templateUrl: './uni-action-widget-container.component.html',
  styleUrls: ['./uni-action-widget-container.component.scss'],
})
export class UniActionWidgetContainerComponent {
}
